// @flow
import client from '../../client'

// Constants
export const GET_USER_PROFILE_ENDPOINT = '/corporate/user/profile/'

/**
 * Returns corporate user profile
 * @param {string} [data.trip_id] The trip id
 * @return {Promise|Error} A resolved Promise with the server response or Rejected with an Error
 */
export const getUserProfile = (data: { trip_id?: string }): Promise<any> =>
  client.get(GET_USER_PROFILE_ENDPOINT, {
    query: data,
  })

export default getUserProfile
